__turbopack_context__.v({
  "className": "poppins_4dc7e32f-module__FruYSG__className",
  "variable": "poppins_4dc7e32f-module__FruYSG__variable",
});
